import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  BaseUrl = environment.apiBaseUrl;

  constructor(private httpClient: HttpClient) { }

  prepareHttpParams() {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('token', 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzaHV2b0BnbWFpbC5jb20iLCJpYXQiOjE2OTkzNDIzNjYsImV4cCI6MTY5OTQyODc2Nn0.Ukx2MDhZ0Dc0QaMFbuFgL18EXHb5ddOyiwGtOookrh0uEttn2FNbV9HsAg1Ge9YMToY2VOV05udEyNEJJqB-TA');
    return queryParams;
  }

  makeHttpRequest(urlExtension: any, requestParams: any, requestMethod: any) {
    const params = this.prepareHttpParams();
    switch (requestMethod) {
      case "GET": {
        return this.httpClient.get<any>(`${this.BaseUrl}/${urlExtension}`, { params: params });
      }
      case "POST": {

        return this.httpClient.post<any>(`${this.BaseUrl}/${urlExtension}`, requestParams, { params: params });
      }
      case "PUT": {

        return new Observable<any>
      }
      case "DELETE": {

        return new Observable<any>
      }
      default: {
        return new Observable<any>
      }
    }
  }
  getWardList(requestParams:any){
    return this.makeHttpRequest("ward/wards",requestParams,"POST");
  }
  createWard(requestParams:any){
    return this.makeHttpRequest("ward/createWard",requestParams,"POST");
  }
  deleteWard(requestParams:any){
    return this.makeHttpRequest("ward/deleteWard",requestParams,"POST");
  }
  createAssessment(requestParams:any){
    return this.makeHttpRequest("assessment/createAssessment",requestParams,"POST");
  }
}
